module.exports = __webpack_public_path__ + "static/media/Warning.d178f0aa.svg";